<template>
  <Card containerClass="mb-5 shadow-sm" titleContainerClass="d-flex justify-content-center">
    <template #cardHeader>
      <div class="card-header">
        <h3 class="card-title align-items-start flex-column">
          {{$t('absences.setting.types')}}
        </h3>
        <div class="card-toolbar">
          <button  class="btn btn-primary" type="button" @click="openCreateTypeModal">
            {{$t('absences.setting.create_absence_type')}}
          </button>
        </div>
      </div>
    </template>
    <template #cardBody>
      <div>
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_types" style="margin-top: 13px !important; cursor:pointer">
          <thead>
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th class="min-w-100px">{{$t('absences.setting.name')}}</th>
              <th class="min-w-200">{{$t('absences.setting.description')}}</th>
              <th class="w-150px">{{$t('absences.setting.color')}}</th>
              <th class="min-w-50px">{{ $t('action') }}</th>
            </tr>
          </thead>
        </table>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "@/Modules/Financial/components/Card.vue";
import {computed, nextTick, onMounted, ref, watch, defineEmits, defineProps} from "vue";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import {Theme} from "@/composables/theming";
import {useSwal} from "@/composables/useSwal";
import { useI18n } from 'vue-i18n'
import {useRouter} from 'vue-router';

const store = useStore()
const { can } = useHasAbility()
const {showSwal} = useSwal()
const { t } = useI18n({ useScope: 'global' })
const router = useRouter()

const props = defineProps({
  tab: {
    type: String,
    required: true
  }
})

const {locale, datatableLocaleUrl} = useLocales()

const tableType = ref(null)

const society = computed(() => store.getters['offices/getSelectedCompany'])

watch(() => society.value, (value) => {
  if(value){
    fetchDatasAbsenceType()
  }
}, { deep: true })

watch(() => locale.value, (value) => {
  loadAbsenceType()
}, { deep: true })

function loadAbsenceType() {
  if(society.value && tableType.value){
    tableType.value?.ajax?.url(`${BASE_URL}/holiday_types/${society.value?.id}/datatables?society_id=${society.value?.id}`).load()
  }
}

function fetchDatasAbsenceType() {
  const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

  tableType.value = $("#kt_datatable_types").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: pageLimit ||  5,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 0, 'desc']],
    ajax: {
      url: BASE_URL + `/holiday_types/${society.value?.id}/datatables?society_id=${society.value?.id}`,
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
        request.setRequestHeader("Company", Ls.get('current.company'));
      }
    },
    columns: [
    { data: "name" }, { data: "description" }, { data: "color" }, { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -4,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          return '<span data-id="'+ e.id +'">' + t + "</span>";
        },
      },
      {
        targets: -3,
        order: "desc",
        className: "dt-center text-center clickable" ,
        render: function (t, a, e, l) {
          let desc = (t == 'null' || t == null) ? '' : t
          return '<span data-id="'+ e.id +'">' + desc + "</span>";
        },
      },
      {
        targets: -2,
        orderable: false,
        className: "dt-center text-center" ,
        render: function (t, a, e, l) {
          return '<div style="width: 100%; border: 8px solid ' + e.color + '; border-radius: 5px; background-color: ' + e.color + '" data-id="'+ e.id +'"></div>';
        },
      },
      {
        width: "10%",
        targets: -1,
        "className": "dt-center text-start",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render=""
          render+='<a href="javascript:;" data-id="'+ e.id +'"  data-name="'+ e.name +'" data-description="'+ e.description +'" data-color="'+ e.color +'" class="btn btn-sm btn-clean btn-icon edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-id="'+ e.id +'"  data-name="'+ e.name +'" data-description="'+ e.description +'" data-color="'+ e.color +'" class="fas fa-edit fs-2" style="color: '+Theme.gray +'"></i></a>'
          render+='<a href="javascript:;" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i  data-id="'+ e.id +'" class="fas fa-trash fs-2" style="color: '+Theme.gray +'"></i></a>'
          return render
        },
      },

    ],
    language: {
      url: datatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_types .edit_btn", (e) => {
    let id = e.target.getAttribute('data-id')
    router.push({name: 'settings-leave-update', params: {id}})
  });

  $(document).on("click", "#kt_datatable_types .delete_btn", async(e) => {
    let id = e.target.getAttribute('data-id')
    await deleteAbsenceType(id)
  });
}

function deleteAbsenceType(id) {
  showSwal(
      t('absences.swal.title'),
      t('absences.swal.absence_types_deleting')
  ).then( async (result) => {
    if (result.value) {
      try {
        store.dispatch('absence_types/deleteAbsenceType', id)
          .then(() => {
              fetchDatasAbsenceType()
              window.toastr['success'](i18n.global.t('absences.setting.absence_types_deleted_successfully'))
          })
      } catch (e) {
      }
    }
  });
}

function openCreateTypeModal(){
  router.push({name: 'settings-leave-create'})
}

onMounted(() => {
  store.dispatch('offices/loadOfficesBySocieties') 
  if(society.value){
    fetchDatasAbsenceType()
  }
})
</script>

<style scoped>

  .end-3 {
    right: 1rem;
  }

</style>
